module.exports = __webpack_public_path__ + "img/elephant.be5030ca.webp";